import barsImage from "../../assets/images/bars.png";

interface TitleSectionProps {
  registrationData?: {
    exam_session?: {
      end_date: string;
    };
  } | null;
}

const TitleSection = ({ registrationData }: TitleSectionProps) => {
  return (
    <div className="gceo-title-section" style={{ position: "relative" }}>
      <h1 className="gceo-main-title" style={{ textAlign: "center" }}>
        REGISTRATION FORM FOR THE{" "}
        {registrationData?.exam_session
          ? new Date(registrationData.exam_session.end_date).getFullYear()
          : "2026"}{" "}
        NW REGIONAL MOCK EXAMINATION
      </h1>
      <img
        src={barsImage}
        alt="Bars"
        style={{
          position: "absolute",
          right: 0,
          top: "50%",
          transform: "translateY(-50%)",
          maxHeight: "50px",
        }}
      />
    </div>
  );
};

export default TitleSection;
